import React, { forwardRef } from 'react'
import Icon from '../Icon'

import './customInputStyles.scss'

const CustomInput = forwardRef((props, ref) => {
  const { icon, placeholderText, value, onClick, onInputClick, onBlur, disabled, onChange, ...rest } = props
  const inputClicked = (e) => {
    onClick && onClick(e)
    onInputClick && onInputClick(e)
  }

  return (
    <div className="custom-input-wrapper" onClick={inputClicked}>
      <input
        {...rest}
        ref={ref}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        className={`custom-input ${disabled ? 'disabled' : ''}`}
        value={value}
        placeholder={placeholderText}
      />
      <Icon
        name={icon}
        width="20px"
        height="100%"
        classes="datepicker-icon"
      />
    </div>
  )
})

export default CustomInput
